import { useEffect, useRef } from 'react';

export const usePrevious = <V>(value: V): V | undefined => {
  const ref = useRef<V>();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};
